<template>
  <div ref="paymentModal" class="modal modal-v modal-v--normal fade show" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body d-flex flex-column align-items-center justify-content-center text-center payment-modal">
          <h2 class="title title--medium mb-5 text-center mt-3 mt-md-0">
            {{ trans.get('profile:modal.payment.header') }}</h2>
          <img v-if="avatarUrl" class="profile-show__modal-avatar" :src="avatarUrl" alt="">
          <div v-if="!avatarUrl && avatars.length" class="payment-modal__grid text-center">
            <div class="avatar-triple">
              <div
                class="avatar-triple__image"
                :style="{'background-image':'url(' + avatars[0] + '?h=100)'}"
              >
              </div>
              <div
                class="avatar-triple__image"
                :style="{'background-image':'url(' + avatars[1] + '?h=200)'}"
              >
              </div>
              <div
                class="avatar-triple__image"
                :style="{'background-image':'url(' + avatars[2] + '?h=100)'}"
              >
              </div>
            </div>
          </div>

          <div v-if="!avatarUrl && avatars.length===0" class="payment-modal__grid text-center">
            <div class="avatar-triple">
              <div
                class="avatar-triple__image"
                style="background:#f5f5f5"
              >
              </div>
              <div
                class="avatar-triple__image"
                style="background:#f5f5f5"
              >
              </div>
              <div
                class="avatar-triple__image"
                style="background:#f5f5f5"
              >
              </div>

            </div>
          </div>

          <!--                    <img v-if="!avatarUrl && avatars.length===0" class="profile-show__modal-image mb-3" src="/img/viluu/background/coins.png"-->
          <!--                         alt="coins">-->

          <p class="desc desc--lightgrey mb-3 text-center">{{ trans.get('profile:modal.payment.slogan') }}</p>
          <router-link :to="{name: 'payment',params: {unit: 'credits'}}" class="button button__fill my-3">
            {{ trans.get('profile:modal.payment.buy') }}
          </router-link>

          <button type="button" class="button button__link button__link--underline " data-dismiss="modal">
            {{ trans.get('profile:modal.payment.close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentModal',
  props: {},
  data() {
    return {
      show: false,
      avatarUrl: null,
    };
  },
  computed: {
    avatars: function () {
      return this.$store.getters['homeProfiles/getRandomAvatars'];
    }
  },
  watch: {
    show(val) {
      if (val) {
        $(this.$refs.paymentModal).modal('show');
      }
    },
  },
  methods: {
    close() {
      this.show = false;
      this.$emit('close');
    }
  },
  mounted() {
    let vm = this;
    $(this.$refs.paymentModal).on('hidden.bs.modal', function (e) {
      vm.close();
    });

    this.$eventHub.$on('PaymentModalOpen', (avatar) => {
      this.$store.dispatch('homeProfiles/load');
      vm.avatarUrl = avatar;
      vm.show = true;
    });
  }
};
</script>

<style scoped>

</style>
